import { BrowserModule } from "@angular/platform-browser";
import { CommonModule } from "@angular/common";
import { NgModule, APP_INITIALIZER } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { HttpModule } from "@angular/http";
import { NgIdleModule } from "@ng-idle/core";
import { MomentModule } from "angular2-moment";
import { AppRoutingModule } from "./app.routing";
import { AppComponent } from "./app.component";
import { ConfigService } from "./_services/config.service";
import { HomeComponent } from "./home/index";
import { SummaryComponent } from "./summary/index";
import { PackageComponent } from "./package/index";
import { CheckoutComponent } from "./checkout/index";
import { MyorderComponent } from "./myorder/index";
import { MycartComponent } from "./mycart/index";
import { OrdersummaryComponent } from "./ordersummary/index";
import { OnholdComponent } from "./onhold/index";
import { FillPipe } from "./fill.pipe"; // import fill pipe here
import { KeysPipe } from "./keys.pipe"; // import json transformation pipe here
import {
  UserService,
  AuthenticationService,
  HttpInterceptorService,
  CookieService,
  UploadService2,
  PackageService,
  ProductService,
  ProjectService,
  DataSourcesService,
  SaveOrderService,
  MyOrderService,
  MyCartService,
  PasswordService,
  ProfileService,
  IntroService,
  SliderService,
  BatchUploadService,
  MessageUploadService,
} from "./_services/index";
import { TemplateComponent } from "./template/template.component";
import { OnholdComponentp } from "./onholdp/onholdp.component";
import { BatchuploadComponent } from "./batchupload/batchupload.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FilterTablePipe } from "./filter-table.pipe";

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    HttpModule,
    HttpClientModule,
    AppRoutingModule,
    MomentModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgIdleModule.forRoot(),
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    SummaryComponent,
    PackageComponent,
    CheckoutComponent,
    MyorderComponent,
    MycartComponent,
    FillPipe,
    KeysPipe,
    TemplateComponent,
    OrdersummaryComponent,
    OnholdComponent,
    OnholdComponentp,
    BatchuploadComponent,
    FilterTablePipe,
  ],
  providers: [
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: (config: ConfigService) => () => config.load(),
      deps: [ConfigService],
      multi: true,
    },
    AuthenticationService,
    UserService,
    HttpInterceptorService,
    CookieService,
    UploadService2,
    PackageService,
    ProductService,
    ProjectService,
    DataSourcesService,
    SaveOrderService,
    MyOrderService,
    MyCartService,
    PasswordService,
    IntroService,
    ProfileService,
    SliderService,
    BatchUploadService,
    MessageUploadService,
    {
      provide: "googleTagManagerId",
      useFactory: (config: ConfigService) => config.get("googleTagManagerId"),
      deps: [ConfigService],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
